// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MobileMessage from 'mobile-message'
import 'mobile-message/dist/message.css'
// VUE use
Vue.use(MobileMessage);
import App from './App'
import router from './router'
import axios from 'axios'  //导入axios
import global_ from './utils/Global.vue'//全局常量
import * as echarts from 'echarts'

import '../vue.config'
import 'lib-flexible'
//import mui from './statics/mui/js/mui.js'
// import './statics/mui/css/mui.css'
import Mui from 'vue-awesome-mui'
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(Mui)
import { Toast, Loading, Alert, Confirm } from 'wc-messagebox'
import 'wc-messagebox/style.css'
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Alert)
Vue.use(Confirm)

Vue.prototype.$http=axios
Vue.prototype.global = global_
Vue.prototype.$loading = Loading
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js